import React, { useState } from 'react'
import { BigNumber, ethers } from 'ethers'

import ConsoleDialog from './ConsoleDialog'
import { getLocalizedWalletError } from './errorMessages'
import { nftV2Abi } from './nftV2Config'

export default function MintLimitPanel({ beforeSubmit, contractAddress, currentLimit, getProvider, maxSupply, onError, onUpdated, showMessage, t }) {
    const [showEdit, setShowEdit] = useState(false)
    const [enabled, setEnabled] = useState(false)
    const [limit, setLimit] = useState('')
    const [error, setError] = useState('')
    const [submitting, setSubmitting] = useState(false)
    const current = currentLimit?.toString?.() || '0'

    const openEditor = () => {
        setEnabled(current !== '0')
        setLimit(current !== '0' ? current : '')
        setError('')
        setShowEdit(true)
    }

    const submit = async () => {
        if (beforeSubmit && beforeSubmit() === false) return
        if (enabled && (!/^\d+$/.test(limit) || BigNumber.from(limit).isZero())) {
            setError(t('请输入大于 0 的整数铸造上限'))
            return
        }
        const nextLimit = enabled ? BigNumber.from(limit) : BigNumber.from(0)
        if (enabled && maxSupply && nextLimit.gt(maxSupply)) {
            setError(t('单钱包铸造上限不能超过 NFT 总量'))
            return
        }

        setSubmitting(true)
        setError('')
        try {
            const provider = await getProvider()
            const contract = new ethers.Contract(contractAddress, nftV2Abi, provider.getSigner())
            await contract.callStatic.updateUserMintLimit(nextLimit)
            const tx = await contract.updateUserMintLimit(nextLimit)
            await tx.wait()
            setShowEdit(false)
            showMessage(t('单钱包铸造上限修改成功'))
            await onUpdated()
        } catch (submitError) {
            setError(getLocalizedWalletError(submitError, t))
            onError(submitError)
        } finally {
            setSubmitting(false)
        }
    }

    return <>
        <div className="mint-limit-card">
            <div>
                <span className="console-overline">{t('铸造规则')}</span>
                <strong>{t('单钱包铸造上限')}</strong>
                <small>{current === '0' ? t('当前不限制单钱包铸造数量') : `${t('每个钱包最多可铸造')} ${current} NFT`}</small>
            </div>
            <button type="button" className="console-button is-secondary" onClick={openEditor}><i className="fa fa-sliders-h" /> {t('修改')}</button>
        </div>

        <ConsoleDialog
            show={showEdit}
            onClose={() => !submitting && setShowEdit(false)}
            title={t('修改单钱包铸造上限')}
            description={t('关闭限制后，每个钱包可在总供应量范围内自由铸造')}
            icon="fa-user-shield"
            closeLabel={t('关闭')}
            footer={<>
                <button type="button" className="console-button is-secondary" disabled={submitting} onClick={() => setShowEdit(false)}>{t('取消')}</button>
                <button type="button" className="console-button is-primary" disabled={submitting} onClick={submit}>{submitting && <i className="fa fa-spinner loading-css" />} {t('提交')}</button>
            </>}
        >
            <label className="console-checkbox">
                <input type="checkbox" checked={enabled} onChange={(event) => { setEnabled(event.target.checked); setError('') }} />
                <span className="console-checkbox__box"><i className="fa fa-check" /></span>
                <span><strong>{t('限制每个钱包的铸造数量')}</strong><small>{t('关闭时链上上限为 0，表示不限制')}</small></span>
            </label>
            {enabled && <label className="console-field">
                <span>{t('每个钱包最多铸造')}</span>
                <div className="console-field__suffix"><input value={limit} onChange={(event) => setLimit(event.target.value.trim())} inputMode="numeric" placeholder="1" /><em>NFT</em></div>
            </label>}
            {error && <div className="console-inline-error"><i className="fa fa-exclamation-circle" /> {error}</div>}
        </ConsoleDialog>
    </>
}
